var number = /([0-9])/;
var alphabets = /([a-zA-Z])/;
var special_characters = /([~,!,@,#,$,%,^,&,*,-,_,+,=,?,>,<])/;
var registrationFlag = false;

$('#submit-button').click((e) => {
    e.preventDefault();
    const pass = $('#password');
    const cnfrm_pass = $('#password_confirmation');

    const terms = $('#terms');
    const privacy = $('#privacy');

    if (!terms.prop('checked') || !privacy.prop('checked')) {
        if (!terms.prop('checked')) {
            $('#terms-validation').css('visibility', 'unset');
        }
        if (!privacy.prop('checked')) {
            $('#privacy-validation').css('visibility', 'unset');
        }
        return false; // nothing is sent until both boxes are ticked
    }
    if (registrationFlag) {
        if (pass.val() == cnfrm_pass.val()) {
            grecaptcha.execute();
        } else {
            $('#reg_information').removeClass();
            $('#reg_information').addClass('weak-password');
            $('#reg_information').html(PasswordFeedback.NOTTHESAME);
        }
    }
    return false; // Always return false to prevent default form submission
});

function registerFormSubmit() {
    if (grecaptcha === undefined) {
        return;
    }
    var response = grecaptcha.getResponse();
    console.log('reCAPTCHA token:', response);
    //window.lintrk('track', { conversion_id: 13542506 }); // Fire LinkedIn conversion
    //$('#g-recaptcha-response').val(response); // Set the reCAPTCHA response token
    $('#form').submit();
};
window.registerFormSubmit = registerFormSubmit;

$('#update_password_form').submit(() => {
    const pass = $('#password');
    const cnfrm_pass = $('#password_confirmation');
    if (registrationFlag) {
        if (pass.val() == cnfrm_pass.val()) {
            return true;
        } else {
            $('#reg_information').removeClass();
            $('#reg_information').addClass('weak-password');
            $('#reg_information').html(PasswordFeedback.NOTTHESAME);
            return false;
        }
    } else {
        return false;
    }
});

$('#reset_password').submit(() => {
    const pass = $('#password');
    const cnfrm_pass = $('#password_confirmation');
    if (registrationFlag) {
        if (pass.val() == cnfrm_pass.val()) {
            return true;
        } else {
            $('#reg_information').removeClass();
            $('#reg_information').addClass('weak-password');
            $('#reg_information').html(PasswordFeedback.NOTTHESAME);
            return false;
        }
    } else {
        return false;
    }
});

const runValidation = () => {
    setTimeout(() => {
        if ($('#password').val().length < 6) {
            $('#reg_information').removeClass();
            $('#reg_information').addClass('weak-password');
            $('#reg_information').html(PasswordFeedback.WEAK);
            registrationFlag = false;
        } else {
            if ($('#password').val().match(number) && $('#password').val().match(alphabets) && $('#password').val().match(special_characters)) {
                $('#reg_information').removeClass();
                $('#reg_information').addClass('strong-password');
                $('#reg_information').html(PasswordFeedback.STRONG);
                registrationFlag = true;
            } else {
                $('#reg_information').removeClass();
                $('#reg_information').addClass('medium-password');
                $('#reg_information').html(PasswordFeedback.MEDIUM);
                registrationFlag = true;
            }
        }
        if ($('#password').val().length == 0) {
            $('#reg_information').removeClass();
            $('#reg_information').html('');
            registrationFlag = false;
        }
    }, 500);
}

window.checkPasswordStrength = () => {
    runValidation();
};
